(() => {
  const containerSelector = [
    '.main-collection__products-grid',
    '.collection-featured__grid',
    '.collection-featured .splide__list'
  ].join(',');

  function isUnavailable(item) {
    return Boolean(item.matches?.('product-card[data-product-available="false"]') ||
      item.querySelector?.('product-card[data-product-available="false"]'));
  }

  function sortContainer(container) {
    const items = Array.from(container.children);
    if (items.length < 2) return;

    const available = items.filter((item) => !isUnavailable(item));
    const unavailable = items.filter(isUnavailable);
    if (!unavailable.length) return;

    const desired = [...available, ...unavailable];
    const alreadySorted = desired.every((item, index) => item === items[index]);
    if (alreadySorted) return;

    const fragment = document.createDocumentFragment();
    desired.forEach((item) => fragment.appendChild(item));
    container.appendChild(fragment);

    const slider = container.closest('.splide');
    if (slider?.splide?.refresh) slider.splide.refresh();
  }

  function sortAll() {
    document.querySelectorAll(containerSelector).forEach(sortContainer);
  }

  let queued = false;
  function scheduleSort() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      sortAll();
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleSort);
  new MutationObserver(scheduleSort).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  scheduleSort();
})();
